/* Mirumi product gallery + swatch picker.
   Swaps the two views (product shot / fur close-up) per colourway,
   keeps price, CTA label, hidden variant input and URL in sync. */
(function () {
  var root = document.querySelector('[data-mru-product]');
  if (!root) return;

  var views = Array.prototype.slice.call(root.querySelectorAll('[data-mru-view]'));
  var swatches = Array.prototype.slice.call(root.querySelectorAll('[data-mru-swatch]'));
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-mru-thumb]'));
  var priceEl = root.querySelector('[data-mru-price]');
  var colourEl = root.querySelector('[data-mru-colour]');
  var variantInput = root.querySelector('[data-mru-variant-input]');
  var addLabel = root.querySelector('[data-mru-add-label]');
  var addBtn = root.querySelector('.mru-product__addbtn');
  // Reserve mode elements (present only when launch_state = reserve)
  var reserveInput = root.querySelector('[data-mru-reserve-input]');
  var reserveBtn = root.querySelector('[data-mru-reserve-btn]');
  var reserveLabel = root.querySelector('[data-mru-reserve-label]');
  var reserveRemaining = root.querySelector('[data-mru-reserve-remaining]');
  // Sold-out -> waitlist fallback groups (present only in reserve mode)
  var reserveGroup = root.querySelector('[data-mru-reserve-group]');
  var waitGroup = root.querySelector('[data-mru-reserve-waitlist]');
  var waitTags = root.querySelector('[data-mru-wait-tags]');
  var waitColour = root.querySelector('[data-mru-wait-colour]');
  var thumbSlots = {
    product: root.querySelector('[data-mru-thumb-slot="product"]'),
    fur: root.querySelector('[data-mru-thumb-slot="fur"]'),
  };

  var active = swatches.filter(function (s) { return s.classList.contains('is-active'); })[0];
  var state = {
    variantId: active ? active.getAttribute('data-variant-id') : (views[0] && views[0].getAttribute('data-variant-id')),
    view: 'product',
  };

  function viewFor(variantId, view) {
    return views.filter(function (v) {
      return v.getAttribute('data-variant-id') === variantId && v.getAttribute('data-view') === view;
    })[0] || null;
  }

  function render() {
    var target = viewFor(state.variantId, state.view) || viewFor(state.variantId, 'product');
    views.forEach(function (v) { v.classList.toggle('is-hidden', v !== target); });

    var main = root.querySelector('[data-mru-main]');
    if (main && target) {
      main.classList.toggle('mru-product__main--fur', target.getAttribute('data-view') === 'fur');
    }

    var hasFur = !!viewFor(state.variantId, 'fur');
    thumbs.forEach(function (t) {
      var kind = t.getAttribute('data-mru-thumb');
      t.classList.toggle('is-active', kind === (target ? target.getAttribute('data-view') : 'product'));
      if (kind === 'fur') t.style.display = hasFur ? '' : 'none';
    });

    ['product', 'fur'].forEach(function (kind) {
      var slot = thumbSlots[kind];
      var source = viewFor(state.variantId, kind);
      if (!slot) return;
      var img = source ? source.querySelector('img') : null;
      slot.innerHTML = '';
      if (img) {
        var clone = img.cloneNode(false);
        clone.removeAttribute('sizes');
        clone.removeAttribute('srcset');
        clone.loading = 'lazy';
        slot.appendChild(clone);
      }
    });
  }

  swatches.forEach(function (s) {
    s.addEventListener('click', function () {
      swatches.forEach(function (o) {
        o.classList.remove('is-active');
        o.setAttribute('aria-pressed', 'false');
      });
      s.classList.add('is-active');
      s.setAttribute('aria-pressed', 'true');
      state.variantId = s.getAttribute('data-variant-id');
      state.view = 'product';

      if (colourEl) colourEl.textContent = s.getAttribute('data-variant-title');
      if (priceEl) priceEl.textContent = s.getAttribute('data-variant-price');
      if (variantInput) variantInput.value = state.variantId;
      if (addLabel && addBtn) {
        var available = s.getAttribute('data-variant-available') === 'true';
        addBtn.disabled = !available;
        var base = addBtn.getAttribute('data-cta-label') || 'Add to cart';
        addLabel.textContent = available ? base + ' — ' + s.getAttribute('data-variant-price') : 'Sold out';
      }

      if (reserveBtn) updateReserve(s);

      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', state.variantId);
        window.history.replaceState({}, '', url.toString());
      }
      render();
    });
  });

  thumbs.forEach(function (t) {
    t.addEventListener('click', function () {
      state.view = t.getAttribute('data-mru-thumb');
      render();
    });
  });

  // Keep the reservation form in sync with the chosen colourway.
  function updateReserve(swatch) {
    var id = swatch.getAttribute('data-reserve-id');
    var available = swatch.getAttribute('data-reserve-available') === 'true';
    var free = swatch.getAttribute('data-reserve-free') === 'true';
    var price = swatch.getAttribute('data-reserve-price') || '';
    var remaining = swatch.getAttribute('data-reserve-remaining'); // may be null if untracked
    var colour = swatch.getAttribute('data-variant-title') || '';

    if (reserveInput && id) reserveInput.value = id;

    if (reserveLabel && reserveBtn) {
      reserveBtn.disabled = !available;
      if (!available) {
        reserveLabel.textContent = reserveBtn.getAttribute('data-soldout-label') || 'Fully reserved';
      } else {
        var base = reserveBtn.getAttribute('data-reserve-label') || 'Reserve yours';
        var suffix = free
          ? (reserveBtn.getAttribute('data-free-suffix') || 'free')
          : price + ' ' + (reserveBtn.getAttribute('data-deposit-suffix') || 'deposit');
        reserveLabel.textContent = base + ' — ' + suffix;
      }
    }

    if (reserveRemaining) {
      if (available && remaining !== null && remaining !== '') {
        reserveRemaining.textContent = 'Only ' + remaining + ' left in ' + colour;
      } else {
        reserveRemaining.textContent = '';
      }
    }

    // Swap the reserve panel for a colour-specific waitlist when sold out.
    if (reserveGroup && waitGroup) {
      reserveGroup.hidden = !available;
      waitGroup.hidden = available;
      if (!available) {
        if (waitColour) waitColour.textContent = colour;
        if (waitTags) waitTags.value = 'waitlist, waitlist-' + colour.toLowerCase();
      }
    }
  }

  render();
  if (reserveBtn && active) updateReserve(active);
})();
